<section class="py-12">
  @if (data.title; as title) {
    <div class="centered-with-padding pb-6">
      <app-title [title]="title" size="h2" />
    </div>
  }

  @if (data.items; as items) {
    @let total = items.length;
    <div class="desk:centered-with-padding w-screen snap-x snap-mandatory overflow-x-auto scroll-smooth desk:w-screen">
      <div class="flex desk:justify-between">
        @for (item of items; track item.image.link; let i = $index) {
          <div
            (click)="openPriceDetailsDialog(item)"
            [class.pl-2.5]="i !== 0"
            [class.pl-5]="i === 0"
            [class.pr-5]="i === total - 1"
            class="group shrink-0 cursor-pointer snap-start desk:p-0">
            <div class="relative size-full h-[311px] w-[calc(100vw-3.5rem)] overflow-hidden rounded-xl desk:w-[353px]">
              <app-image
                [hoverEffect]="true"
                [image]="item.image"
                [isPriority]="!isImageInPreviousBlocks && $index < 3"
                [pregenerationSize]="{ width: 353, height: 311 }" />
              <div
                class="drop-shadow-custom absolute inset-x-0 bottom-3 mx-auto flex h-[68px] w-[calc(100%-1.25rem)] flex-col justify-center rounded-xl bg-gray-light px-2.5">
                <div class="flex justify-between pb-2">
                  <span class="font-title text-[20px]">
                    {{ item.implantation.type }} - {{ item.implantation.surface }}
                  </span>
                  <span class="font-title text-[20px]">{{ item.price }}</span>
                </div>
                <div class="flex justify-between">
                  <span class="flex items-center gap-x-1.5 text-[12px] desk:text-[14px]">
                    {{ "GLOBAL.VIEW_PRICE_DETAILS" | translate }}
                    <app-svg [width]="12" src="assets/icons/arrow-right.svg" />
                  </span>
                  @if (item.ecoPart) {
                    <span class="text-end text-[10px]">
                      {{ "GLOBAL.INCLUDING_ECO_PART" | translate: { price: item.ecoPart } }}
                    </span>
                  }
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
</section>
